<template>
    <v-dialog v-model="dialog">
        <template #activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" title="connect">mdi-connection</v-icon>
        </template>

        <v-card class="pa-5">
            <div class="text-h6 d-flex">
                <span>Connect your cluster</span>
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>

            <p>Add the Coroot helm repository:</p>
            <pre v-hl>
helm repo add coroot https://coroot.github.io/helm-charts
helm repo update coroot
            </pre>

            <p class="subtitle-1">To determine the optimal configuration, choose the number of nodes in your cluster:</p>
            <v-slider v-model="size" step="1" :max="sizes.length-1" :tick-labels="sizes.map(s => s.label)" class="mb-5" />

            <p>Deploy Coroot to your cluster:</p>
            <pre class="hl">
helm upgrade --install --namespace coroot --create-namespace \
  --set corootConnect.enabled=true \
  --set corootConnect.projectToken={{token}} \
  --set prometheus.server.persistentVolume.size={{vars.prometheus.volume}} \
  --set clickhouse.persistence.size={{vars.clickhouse.volume}} \
  coroot coroot/coroot</pre>

            <v-alert v-if="!connected" outlined text color="primary">
                Waiting for the cluster to connect...
                <v-progress-circular indeterminate color="primary" />
            </v-alert>
            <v-alert v-else outlined text color="success">
                The cluster is connected.
            </v-alert>

            <div v-if="!connected">
                <p>Check the <var>coroot-connect</var> logs if the cluster fails to connect.</p>
                <pre v-hl>
kubectl -n coroot logs -f deployments/coroot-connect
                </pre>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        projects: Array,
        token: String,
        open: Boolean,
    },

    data() {
        return {
            dialog: this.open,
            size: 1,
        };
    },

    computed: {
        sizes() {
            return [
                {value: 10, label: '1 - 10'},
                {value: 20, label: '10 - 20'},
                {value: 50, label: '20 - 50'},
                {value: 100, label: '50 - 100'},
                {value: 150, label: '> 100'},
            ];
        },
        vars() {
            const nodes = this.sizes[this.size].value;
            return {
                prometheus: {volume: nodes + 'Gi'},
                clickhouse: {volume: nodes * 5 + 'Gi'},
            };
        },
        connected() {
            const p = this.projects.find(p => p.token === this.token);
            return p && p.connect.status !== 'unknown';
        },
    },

    methods: {
    },
}
</script>

<style scoped>

</style>